<template>
    <div class="d-flex h-100" style="flex-direction: column;">
        <settings v-if="active_step == 'reference_step1'" :controller="controller" />

        <calc v-if="active_step.startsWith('reference_step2')" :controller="controller"
            :active_step="active_step" v-on:set_active_step="(step_id) => $emit('set_active_step', step_id)"
        />

        <corrections v-if="active_step == 'reference_step3'" :controller="controller" />

        <details_reference v-if="active_step == 'reference_step4'" :controller="controller" />
    </div>
</template>

<script>
import calc from "./calc"
import settings from "./settings"
import corrections from "./corrections"
import details_reference from "./details"
import Reference_controller from "./controller"

export default {
    props :
	{
		id : String,
		group_id : String,
		cost_evaluation_data : Object,
        active_step : String,
		not_editable : Boolean,
	},

    components :
    {
        settings,
        calc,
        corrections,
        details_reference
    },

    data()
    {
        return {
            data : null,
            controller : null
        }
    },

    beforeMount()
    {
        this.data = this.cost_evaluation_data.reference
        this.controller = new Reference_controller(this,
            this.cost_evaluation_data.group_id,
            this.cost_evaluation_data.id,
            this.cost_evaluation_data.reference,
            this.not_editable
        )
    }
}
</script>
